import { Outlet } from 'react-router'
import { AuthProvider } from '../contexts/authContext'
import LoginPromptProvider from '../contexts/LoginPromptContext'

function RootLayout() {
  return (
    <AuthProvider>
      <div className='min-h-screen bg-base-200'>
          <LoginPromptProvider>
            <Outlet/>
          </LoginPromptProvider>
      </div>
    </AuthProvider>
  )
}

export default RootLayout